/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Currency_Toggle_Ars_Surcharge_TooltipInputs */

const es_admin_billing_currency_toggle_ars_surcharge_tooltip = /** @type {(inputs: Admin_Billing_Currency_Toggle_Ars_Surcharge_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los pagos en pesos se procesan a través de Mercado Pago con un recargo del 5%.`)
};

const en_admin_billing_currency_toggle_ars_surcharge_tooltip = /** @type {(inputs: Admin_Billing_Currency_Toggle_Ars_Surcharge_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments in Argentine pesos are processed through Mercado Pago with a 5% surcharge.`)
};

/**
* | output |
* | --- |
* | "Payments in Argentine pesos are processed through Mercado Pago with a 5% surcharge." |
*
* @param {Admin_Billing_Currency_Toggle_Ars_Surcharge_TooltipInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_currency_toggle_ars_surcharge_tooltip = /** @type {((inputs?: Admin_Billing_Currency_Toggle_Ars_Surcharge_TooltipInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Currency_Toggle_Ars_Surcharge_TooltipInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_currency_toggle_ars_surcharge_tooltip(inputs)
	return en_admin_billing_currency_toggle_ars_surcharge_tooltip(inputs)
});
export { admin_billing_currency_toggle_ars_surcharge_tooltip as "admin.billing.currency_toggle.ars_surcharge_tooltip" }